import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { companyLocationOptionFromEntity } from 'components/forms/autocomplete/CompanyLocation';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import List from 'components/List';

import FormInput from 'components/forms/FormInput';
import FormSwitchery from 'components/forms/FormSwitchery';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormTags from 'components/forms/FormTags';

import { ROLE_EMPLOYEE } from 'js/constants';
import may from 'js/security';

class UserProfile extends EntityPropsUpdater {
  updateProfile = (propertyName, value) => {
    this.updateEntity(propertyName, value, ['profile']);
  };

  render() {
    const {
      intl: { messages },
      entityLoaded,
      entity,
      disabled,
      inModal,
      user,
      leadTags,
    } = this.props;


    return !may(ROLE_EMPLOYEE, user.roles) ? (
      <div className="clearfix">
        {entityLoaded && (
          <Row>
            <Col xs={12} md={inModal ? 12 : 4}>
              <div className="panel panel-transparent">
                <div className="panel-body">
                  <div className="form-group-attached">
                    <div className="form-group form-group-default padding-10">
                      <FormSwitchery
                        name="newsletter"
                        checked={entity.getProfile().getNewsletter()}
                        value
                        label={messages.newsletter}
                        onChange={this.updateProfile}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    ) : (
      <div class="clearfix">
        {entityLoaded && (
          <Row>
            <Col xs={12} md={inModal ? 12 : 4}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.employee_data}</p>
                  <div class="form-group-attached">
                    {may('ROLE_ADMIN', user.roles) && <div class="form-group form-group-default padding-10">
                      <FormSwitchery
                        name="isActive"
                        checked={entity.getIsActive()}
                        value
                        label={messages.is_active}
                        onChange={this.updateEntity}
                      />
                    </div>}
                    {may('ROLE_ADMIN', user.roles) && <div class="form-group form-group-default padding-10">
                      <FormSwitchery
                        name="isRenewPasswordAtNextLogin"
                        checked={entity.getIsRenewPasswordAtNextLogin()}
                        value
                        label={messages.is_renew_password_at_next_login}
                        onChange={this.updateEntity}
                      />
                    </div>}
                    <div className="form-group form-group-default padding-10">
                      <FormSwitchery
                        name="newsletter"
                        checked={entity.getProfile().getNewsletter()}
                        value
                        label={messages.newsletter}
                        onChange={this.updateProfile}
                      />
                    </div>
                    <div className="form-group form-group-default padding-10">
                      <FormSwitchery
                        name="editorAutosave"
                        checked={entity.getProfile().getEditorAutosave()}
                        value
                        label={messages.editorAutosave}
                        onChange={this.updateProfile}
                      />
                    </div>
                    <FormInput
                      label={messages.job_title}
                      name="jobTitle"
                      value={entity.getProfile().getJobTitle()}
                      meta={entity.getProfile().getJobTitleMetaInformation()}
                      validation={entity.getProfile().getJobTitleValidationResult()}
                      onChange={this.updateProfile}
                    />
                    <FormAutocomplete
                      label={messages.location}
                      name="location"
                      value={companyLocationOptionFromEntity(entity.getLocation())}
                      meta={entity.getLocationMetaInformation()}
                      validation={entity.getLocationValidationResult()}
                      onChange={(name, location) => {
                        this.updateEntity(name, {
                          id: location.location_id,
                          name: location.name,
                          street: location.street,
                          house_number: location.house_number,
                          apartment_number: location.apartment_number,
                          zip_code: location.zip_code,
                          city: location.city,
                          coordinates: { lat: location.coordinates.lat, lng: location.coordinates.lng },
                        });
                      }}
                      returnValueObject
                      autocompleteType="whiteLabelLocation"
                      urlFilters={{ filters: { matchEmployee: entity.getUsername() } }}
                      complete
                      disabled={disabled}
                    />
                    {/*
                    <div class="form-group form-group-default padding-10">
                      <FormSwitchery
                        name="isProfilePublic"
                        checked={entity.getIsProfilePublic()}
                        value
                        label={messages.is_profile_public}
                        onChange={this.updateEntity}
                      />
                    </div>
                    <List noRender listName="leadTags" url="/api/leadtags.json" list={leadTags} />
                    <FormTags
                      label={messages.match_lead_tags}
                      name="leadTags"
                      value={entity.getLeadTags()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      messages={messages}
                      options={leadTags.data.list.map(leadTag => {
                        return { value: leadTag, label: leadTag };
                      })}
                    />
                    */}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
UserProfile.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    leadTags: state.list.leadTags,
  };
};

export default injectIntl(connect(mapStateToProps)(UserProfile));
